



























































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Controllers, settingName } from "@infoland/iprova-api";
import { TranslateResult } from "vue-i18n/types";

enum PasswordStrength {
    weak = 2,
    medium = 3,
    strong = 4
}

@Component({})
export default class PasswordStrengthInput extends Vue {
    @Prop() value: string;
    @Prop() rules: ((v: string) => true | TranslateResult)[];

    passwordStrengthScore: number = null;
    minPasswordStrength: PasswordStrength = PasswordStrength.weak;
    errorMessages: string[] = [];

    /**
     * Fires when created
     */
    created() {
        this.onCreatedAsync();
    }

    /**
     * validates input
     */
    validate() {
        (this.$refs.passwordStrengthInput as any).validate();
        //note: this function is only a wrapper around form.validate to make mocking the form validation result easy in unit test
    }

    /**
     * Fires when the component is created (method created to have the created hook to be mockable)
     */
    async onCreatedAsync() {
        //sets the min password length
        await this.initMinPasswordStrengthAsync();
    }

    /**
     * Sets the minimum password strength setting from iProva
     */
    async initMinPasswordStrengthAsync() {
        let minPasswordStrengthString = await Controllers.SettingsController.getSettingAsync<string>(settingName.min_password_strength);
        this.minPasswordStrength = PasswordStrength[minPasswordStrengthString];
    }

    /**
     * Sets the currently password strength score
     */
    async requestPasswordStrengthAsync() {
        if (this.value && this.value.trim().length > 0) {
            let result = (await Controllers.UsersController.requestPasswordStrengthAsync(this.value.trim())) as string;
            this.passwordStrengthScore = Number(result);

            this.validate();
        } else {
            this.passwordStrengthScore = null;
        }
    }

    /**
     * Gets validation rules for password field
     * @return {String} validation
     */
    get newPasswordRules() {
        let newPasswordRules = [
            v => !!v || this.$t("settings.changePassword.isRequired"),
            v => v.trim().length == v.length || this.$t("settings.changePassword.passwordSpaces"),
            v => this.passwordStrengthScore >= this.minPasswordStrength || this.$t("settings.changePassword.passwordNotStrongEnough")
        ];
        if (this.rules) {
            newPasswordRules = newPasswordRules.concat(this.rules);
        }
        return newPasswordRules;
    }

    /**
     * Watch the input value for changes
     */
    @Watch("value") async valueWatchAsync() {
        await this.requestPasswordStrengthAsync();
    }
}
